module.exports = __webpack_public_path__ + "static/media/house-bg-home.0aa90e86.jpg";